import React from "react"
import HeaderBanner from "./HeaderBanner"
import HeaderBannerUS from "./HeaderBannerUS"
import HeaderBannerUK from "./HeaderBannerUK"
import AboutBlock from "./AboutBlock"
import ResellerBlock from "./ResellerBlock"
import HostingBlock from "./HostingBlock"
import Faq from "../faq/FaqGeneral"
import AppBlock from "./AppBlock"
import Seo from "../../components/seo"
import useGlobal from "../../context/GlobalContext"
import ClientReviews from "./ClientReviews"
import FeaturedTlds from "../domains/FeaturedTlds"
import bannerOgImage from "../../../static/img/og/staticHostingOg.jpg"
import EmailBlock from "./EmailBlock"
import WordpressBlock from "./WordpressBlock"

const HomePage = () => {
  const { currentRouteOption } = useGlobal()
  const { lang } = currentRouteOption || {}

  const pageTitle = {
    "en-IN": "Welcome to MotherHost: Your Gateway to Powerful Web Solutions - India",
    "en-US": "Welcome to MotherHost: Your Gateway to Powerful Web Solutions - USA",
    "en-GB": "Welcome to MotherHost: Your Gateway to Powerful Web Solutions - UK",
    "default": "",
  }

  const pageDesc = {
    "en-IN": "Discover reliable web hosting, domain registration, and SSL services at MotherHost. Elevate your online presence with our expert solutions.",
    "en-US": "Discover reliable web hosting, domain registration, and SSL services at MotherHost. Elevate your online presence with our expert solutions.",
    "en-GB": "Discover reliable web hosting, domain registration, and SSL services at MotherHost. Elevate your online presence with our expert solutions.",
    "default": "",
  }

  const pageKeywords = {
    "en-IN": "web hosting, domain registration, SSL certificates, website hosting, hosting services, MotherHost, domain hosting, SSL security, website solutions",
    "en-US": "web hosting, domain registration, SSL certificates, website hosting, hosting services, MotherHost, domain hosting, SSL security, website solutions",
    "en-GB": "web hosting, domain registration, SSL certificates, website hosting, hosting services, MotherHost, domain hosting, SSL security, website solutions",
    "default": "",
  }

  const headerBannerComponent = {
    "en-IN": <HeaderBanner />,
    "en-US": <HeaderBannerUS />,
    "en-GB": <HeaderBannerUK />,
    "default": <HeaderBanner />,
  }

  return (
    <>
        <Seo
          title={pageTitle[lang] || pageTitle["default"]}
          desc={pageDesc[lang] || pageDesc["default"]}
          pathname="/"
          keywords={pageKeywords[lang] || pageKeywords["default"]}
          bannerImage={bannerOgImage}
        />
        {headerBannerComponent[lang] || headerBannerComponent["default"]}
        <HostingBlock />
        <ResellerBlock />
        <section className="pricing text-start bg-dark">
          <div className="container-xl">
            <div className="row ">
              <FeaturedTlds />
            </div>
          </div>
        </section>
        <WordpressBlock />
        <EmailBlock />
        <AppBlock />
        <AboutBlock />
        <ClientReviews SlideToShow={3} SlideToScroll={1} />   
        <Faq />
    </>
  )
}

export default HomePage
